import React from 'react';
import styled from 'styled-components';
import { Input } from '../../../elements/Input';
import { Text } from '../../../elements/Typography';
import { Cell } from './Cell';
const StyledInput = styled(Input) `
  --input-background: transparent;
  --input-color: ${({ theme }) => theme.foreground};

  border-radius: var(--table-cell-border-radius);
  box-shadow: 0 0 0 var(--input-inline-outline, 0px)
    var(--input-inline-outline-color, ${({ theme }) => theme.primary.background});
  position: relative;

  &:hover {
    --input-inline-outline: 1px;
    --input-inline-outline-color: ${({ theme }) => theme.primary.background};
  }

  &:focus,
  &:focus-within {
    --input-inline-outline: 1px;

    z-index: 3;
  }
`;
const TextDisplayCell = (props) => {
    const { weight, value, displayVariant, children } = props;
    return (React.createElement(Cell, null,
        React.createElement(Text, { monospace: displayVariant === 'monospaced', weight: weight, size: 14 }, value),
        children));
};
const TextInputCell = (props) => {
    return React.createElement(StyledInput, { ...props });
};
export const TextCell = ({ displayVariant, isEditable, weight, ...props }) => {
    return isEditable ? (React.createElement(TextInputCell, { ...props })) : (React.createElement(TextDisplayCell, { displayVariant: displayVariant, weight: weight, ...props }));
};
//# sourceMappingURL=TextCell.js.map